(async function () {
  // ==================== UTILS ==================== //

  const reset = (collection, className) => {
    for (let elt of collection) {
      elt.classList.remove(className);
    }
  };

  const removeClass = (collection, className) => {
    for (let elt of document.querySelectorAll(collection)) {
      elt.classList.remove(className);
    }
  };

  // ==================== PRICES ==================== //

  class SliderPrices extends HTMLElement {
    constructor() {
      super();
      this.setSlider();
    }

    setSlider() {
      new Splide(this, {
        type: "slide",
        perPage: 3,
        gap: 25,
        arrows: false,
        pagination: true,
        updateOnMove: true,
        breakpoints: {
          800: {
            perPage: 1,
            padding: 150,
          },
          500: {
            perPage: 1,
            gap: 15,
            padding: 40,
          },
        },
      }).mount();
    }
  }

  customElements.define("slider-prices", SliderPrices);

  // // ==================== TOGGLE PRODUCTS ==================== //

  // class ToggleProducts extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.toggle = this.querySelector(".toggle");
  //     this.setEvents();
  //   }

  //   setEvents() {
  //     const products = this.querySelectorAll(".item");
  //     for (let product of products) {
  //       const index = Number(product.dataset.index);
  //       product.addEventListener("click", () => {
  //         reset(products, "active");
  //         removeClass(".slider-prices", "active");
  //         product.classList.add("active");
  //         this.toggle.classList.remove("left", "right");
  //         if (index === 1) {
  //           this.toggle.classList.add("left");
  //           document
  //             .querySelector(".slider-prices.scooter")
  //             .classList.add("active");
  //         }
  //         if (index === 2) {
  //           this.toggle.classList.add("right");
  //           document
  //             .querySelector(".slider-prices.velo")
  //             .classList.add("active");
  //         }
  //       });
  //     }
  //   }
  // }

  // customElements.define("toggle-products", ToggleProducts);

  // ==================== BOX IMAGE ==================== //

  class BoxImage extends HTMLElement {
    constructor() {
      super();
      console.log(this.innerHTML);
    }
  }

  customElements.define("box-image", BoxImage);

  // ==================== PAGE SCOOTER ==================== //

  /**
   * Initialisation de cart.js
   */

  const LEASING_NUMBER_MONTHS = 48;

  jQuery(function () {
    // On récupère le panier en json
    const cartContents = fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        // On initialise Cart.js
        CartJS.init(data);
      });
  });

  const getLeasingPrice = async ({ items }) => {
    console.log(items);
    const rawResponse = await fetch(
      "https://brumaire-mypangee-integration.herokuapp.com/getShoppingPrice",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: items,
          durationInMonths: LEASING_NUMBER_MONTHS,
        }),
      }
    );
    return await rawResponse.json();
  };

  const getLeasingCartUrl = async ({ items }) => {
    const rawResponse = await fetch(
      "https://brumaire-mypangee-integration.herokuapp.com/getShoppingCartUrl",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: items,
          durationInMonths: LEASING_NUMBER_MONTHS,
        }),
      }
    );
    return await rawResponse.json();
  };

  const addToCart = async () => {
    document.querySelector(".button.next").innerHTML =
      '<img class="h-6" src="https://cdn.shopify.com/s/files/1/0609/2590/3040/t/2/assets/loader.gif?v=531280867754825472" role="presentation">';

    // On ajoute les accessoires au panier virtuel
    for (let accessoire of document.querySelectorAll(
      ".accessoires .in-cart, .services .in-cart"
    )) {
      VIRTUAL_CART.push({ id: accessoire.dataset.variant });
    }

    let date_estimee = allProducts.scooter
      ? allProducts.scooter.filter(
          (product) =>
            product.id === document.querySelector("#productSelect").value
        )[0].date_estimee
      : null;

    if (document.querySelector(".wrapper-scooter.velo") != undefined) {
      VIRTUAL_CART.push({
        id: document.querySelector("#productSelect").value,
        quantity: 1,
        properties: {
          "Livraison Estimée": date_estimee,
        },
      });
    } else {
      if (document.querySelector(".model") != undefined) {
        let model = Number(
          document
            .querySelector(".model .option.active h4")
            .dataset.value.split(" Watts")[0]
        );

        // On ajoute le scooter au panier virtuel
        if (date_estimee && date_estimee != "") {
          VIRTUAL_CART.push({
            id: document.querySelector("#productSelect").value,
            quantity: 1,
            properties: {
              // "Prix d'origine ": `${model === 3000 ? "3390,00€" : "4790,00€"}`,
              // "Prime France ": `${model === 3000 ? "-540,00€" : "-720,00€"}`,
              "Livraison Estimée": date_estimee,
            },
          });
        } else {
          VIRTUAL_CART.push({
            id: document.querySelector("#productSelect").value,
            quantity: 1,
            // properties: {
            //   "Prix d'origine ": `${model === 3000 ? "3390,00€" : "4790,00€"}`,
            //   "Prime France ": `${model === 3000 ? "-540,00€" : "-720,00€"}`,
            // },
          });
        }
      }
    }

    const itsLeasingProduct = document.querySelector(
      ".wrapper-scooter-location"
    );

    if (itsLeasingProduct && (STEP === 3 || isMobile())) {
      const leasingPageUrl = await getLeasingCartUrl({
        items: getItemsInCartForLeasing({ toGetPrice: false }),
      });
      if (leasingPageUrl) {
        window.location = leasingPageUrl.url;
        return;
      }
    }

    if (!itsLeasingProduct) {
      // On ajoute le panier virtuel au panier
      CartJS.addItems(VIRTUAL_CART, {
        success: function (data, textStatus, jqXHR) {
          window.location = "/cart";
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error(jqXHR, textStatus, errorThrown);
        },
      });
    }
  };

  let STEP = 1;

  const wrapperSteps = document.querySelector(".wrapper-steps");
  const amountSteps = document.querySelector(".steps-controls .amount");

  const updateStep = () => {
    wrapperSteps.style.transform = "translateX(-" + (STEP - 1) * 33.33 + "%)";
    amountSteps.style.width = STEP * 33.33 + "%";
    // On active toutes les steps précédentes
    for (let i = 1; i <= STEP; i++) {
      document
        .querySelector(".steps-controls .step:nth-child(" + i + ")")
        .classList.add("active");
    }
    if (STEP === 3 || isMobile()) {
      document.querySelector(".button.next .content").textContent = "Commander";
    } else {
      document.querySelector(".button.next .content").textContent = "Suivant";
    }
  };

  let _hasClicked = false;

  document
    .querySelector(".atc-form .controls .next")
    ?.addEventListener("click", async () => {
      if (!isMobile()) {
        if (STEP < 3) {
          STEP++;
          updateStep(STEP);
        } else if (STEP === 3) {
          if (!_hasClicked) {
            _hasClicked = true;
            await addToCart();
          }
        }
      } else {
        if (!_hasClicked) {
          _hasClicked = true;
          await addToCart();
        }
      }
    });

  const isMobile = () => {
    if (window.innerWidth < 800) return true;
  };

  for (let step of document.querySelectorAll(".steps-controls .step")) {
    step?.addEventListener("click", function () {
      this.classList.add("active");
      STEP = Number(this.dataset.step);
      if (!isMobile()) updateStep();
    });
  }

  let winHeight = window.innerHeight;

  for (let section of document.querySelectorAll(".section:not(.active)")) {
    if (window.scrollY > section.offsetTop - winHeight / 2) {
      section.classList.add("active");
    }
  }

  window.addEventListener("scroll", (event) => {
    for (let section of document.querySelectorAll(".section:not(.active)")) {
      if (window.scrollY > section.offsetTop - winHeight / 2) {
        section.classList.add("active");
      }
    }
  });

  for (let option of document.querySelectorAll(".model .option")) {
    option?.addEventListener("click", () => {
      if (option.querySelector(".value").dataset.value.includes("3000")) {
        SCOOTER.model = 3000;
      } else {
        SCOOTER.model = 4700;
      }
    });
  }

  // ==================== MAIN HEADER ==================== //

  class MainHeader extends HTMLElement {
    constructor() {
      super();

      this.submenuOpened = false;

      this.submenu = this.querySelector(".submenu");

      this.scooterButton = this.querySelector("nav p.scooter");
      this.tryButton = this.querySelector(".button.try");
      this.buyButton = this.querySelector(".button.order");
      this.accessoiresButton = this.querySelector("nav p.accessoires");

      this.mobileOpened = false;
      this.submenuMobileOpened = false;

      this.burger = this.querySelector(".burger");
      this.mobileMenu = this.querySelector(".mobile-menu");
      this.track = this.mobileMenu.querySelector(".track");
      this.scooterButtonMobile = this.mobileMenu.querySelector(
        ".open-scooter-mobile"
      );
      this.accessoiresButtonMobile = this.mobileMenu.querySelector(
        ".open-accessoires-mobile"
      );
      this.buyButtonMobile = this.mobileMenu.querySelector(".button.order");
      this.tryButtonMobile = this.mobileMenu.querySelector(".button.try");
      this.backButtons = this.mobileMenu.querySelectorAll(".back");

      this.setEvents();
      this.setEventsMobile();

      this.setSlider();
    }

    setSlider() {
      new Splide(this.querySelector(".splide"), {
        perPage: 1,
        arrows: false,
        pagination: false,
      }).mount();
    }

    openSubmenu() {
      this.submenuOpened = true;
      gsap.to(this.submenu, { y: 0, duration: 1, ease: "elastic.out(1, .75)" });
    }

    closeSubmenu() {
      this.submenuOpened = false;
      removeClass(".submenu-wrapper", "active");
      gsap.to(this.submenu, {
        y: -400,
        duration: 0.5,
        ease: Back.easeIn.config(2),
      });
    }

    showSubmenuByClassName(submenuClassName) {
      if (!this.submenuOpened) this.openSubmenu();
      removeClass(".submenu-wrapper", "active");
      this.submenu.querySelector(submenuClassName).classList.add("active");
    }

    setEvents() {
      document.addEventListener("click", (event) => {
        if (this.submenuOpened) {
          if (this && !this.contains(event.target)) {
            this.closeSubmenu();
          }
        }
      });

      this.scooterButton?.addEventListener("click", () => {
        this.showSubmenuByClassName(".scooters");
      });

      this.buyButton?.addEventListener("click", () => {
        this.showSubmenuByClassName(".buy");
      });

      this.tryButton?.addEventListener("click", () => {
        this.showSubmenuByClassName(".try");
      });

      this.accessoiresButton?.addEventListener("click", () => {
        this.showSubmenuByClassName(".accessoires");
      });
    }

    openMenuMobile() {
      this.mobileOpened = true;
      gsap.to(this.mobileMenu, {
        y: 0,
        duration: 1,
        ease: "elastic.out(.5, .75)",
      });
    }

    closeMenuMobile() {
      this.mobileOpened = false;
      gsap.to(this.mobileMenu, {
        y: "-100vh",
        duration: 1,
        ease: "elastic.out(.5, .75)",
      });
      this.closeSubmenuMobile();
    }

    openSubmenuMobile() {
      this.submenuMobileOpened = true;
      gsap.to(this.track, {
        x: "-100vw",
        duration: 1,
        ease: "elastic.out(1, .75)",
      });
    }

    closeSubmenuMobile() {
      this.submenuMobileOpened = false;
      gsap.to(this.track, { x: 0, duration: 1, ease: "elastic.out(1, .75)" });
    }

    showMobileSubmenuByClassName(submenuClassName) {
      if (!this.submenuMobileOpened) this.openSubmenuMobile();
      removeClass(".submenu-mobile-wrapper", "active");
      document.querySelector(submenuClassName).classList.add("active");
    }

    setEventsMobile() {
      this.burger?.addEventListener("click", () => {
        if (this.mobileOpened) {
          this.closeMenuMobile();
        } else {
          this.openMenuMobile();
        }
      });

      this.scooterButtonMobile?.addEventListener("click", () => {
        this.showMobileSubmenuByClassName(".submenu-mobile-wrapper.scooter");
      });

      this.accessoiresButtonMobile?.addEventListener("click", () => {
        this.showMobileSubmenuByClassName(
          ".submenu-mobile-wrapper.accessoires"
        );
      });

      this.tryButtonMobile?.addEventListener("click", () => {
        this.showMobileSubmenuByClassName(".submenu-mobile-wrapper.try");
      });

      this.buyButtonMobile?.addEventListener("click", () => {
        this.showMobileSubmenuByClassName(".submenu-mobile-wrapper.order");
      });

      for (let backButton of this.backButtons) {
        backButton?.addEventListener("click", () => {
          this.closeSubmenuMobile();
        });
      }
    }
  }

  customElements.define("main-header", MainHeader);

  const getCartPrice = () => {
    let _amount = 0;
    // On ajoute le prix du scooter
    _amount += parseFloat(
      document
        .querySelector("#productSelect")
        .options[
          document.querySelector("#productSelect").selectedIndex
        ].text.split(" | ")[1]
        .replace(" ", "")
    );
    // On ajoute le prix des accessoires sélectionnés
    for (let accessoire of document.querySelectorAll(
      ".accessoires .in-cart, .services .in-cart"
    )) {
      _amount += parseFloat(
        accessoire
          .querySelector(".price")
          .textContent.replace(" €", "")
          .replace(",", ".")
      );
    }

    // On arrondie le prix à deux chiffres après la virgule
    _amount = Math.round((_amount + Number.EPSILON) * 100) / 100;

    // On transforme le prix en chaîne de caractères
    _amount = _amount.toString().replace(".", ",");
    // On gère les zéros en fin de prix
    if (_amount.includes(",")) {
      let _afterCom = _amount.split(",")[1];
      if (_afterCom.length === 1) _amount = _amount + "0";
    } else {
      _amount = _amount + ",00";
    }
    return _amount;
  };

  const createLine = (title, price, image, variant) => {
    const _line = document.createElement("div");
    _line.classList.add("line");

    const _imageWrapper = document.createElement("div");
    _imageWrapper.classList.add("image");
    const _img = document.createElement("img");
    _img.src = image;
    _imageWrapper.appendChild(_img);

    const _left = document.createElement("div");
    _left.classList.add("left");

    const _text = document.createElement("div");

    const _title = document.createElement("p");
    _title.textContent = title;
    _text.appendChild(_title);

    if (variant) {
      const _variant = document.createElement("p");
      _variant.textContent = variant;
      _text.appendChild(_variant);
    }

    const _price = document.createElement("p");
    _price.textContent = price;

    _left.appendChild(_imageWrapper);
    _left.appendChild(_text);

    _line.appendChild(_left);
    _line.appendChild(_price);

    return _line;
  };

  const getItemsInCartForLeasing = ({ toGetPrice }) => {
    let _items = [];

    // On ajoute le scooter
    const currentScooter = allProducts.scooter.find(
      (item) =>
        item.id ===
        document.querySelector("#productSelect").options[
          document.querySelector("#productSelect").selectedIndex
        ]?.value
    );
    if (currentScooter) {
      const item = {
        equipmentType: "PRODUCT",
        categoryId: 99,
        quantity: 1,
        trademark: currentScooter.product_title,
        shippingDeliveryTimeInDays: 7,
        shippingType: "HOME_DELIVERY",
        shippingUnitaryCostInCts: 19900,
      };
      if (!toGetPrice) {
        item.equipmentState = "NEW";
        item.image = "https:" + currentScooter.image;
        item.reference = currentScooter.sku
          ? currentScooter.sku
          : "Sans Référence";
        item.model =
          currentScooter.title != "Default Title"
            ? currentScooter.title
            : "Sans Option";
        item.link = currentScooter.product_link;
        item.priceInCts = parseInt(currentScooter.price_no_money);
        item.cashPriceInCts = parseInt(currentScooter.price_no_money);
      }
      if (toGetPrice) {
        item.unitaryPriceInCts = parseInt(currentScooter.price_no_money);
        item.unitaryCashPriceInCts = parseInt(currentScooter.price_no_money);
      }
      _items.push(item);
    }
    // On ajoute les accessoires
    for (let accessoire of document.querySelectorAll(
      ".accessoires .in-cart, .services .in-cart"
    )) {
      const currentAccessoire = allProducts.accessoires.find(
        (item) => item.id === accessoire.dataset.variant
      );
      if (currentAccessoire) {
        const item = {
          equipmentType: "ACCESSORY",
          categoryId: 99,
          quantity: 1,
          trademark: currentAccessoire.product_title,
          shippingDeliveryTimeInDays: 7,
          shippingType: "HOME_DELIVERY",
          shippingUnitaryCostInCts: 0,
        };
        if (!toGetPrice) {
          item.equipmentState = "NEW";
          item.image = "https:" + currentAccessoire.image;
          item.reference = currentAccessoire.sku
            ? currentAccessoire.sku
            : "Sans Référence";
          item.model =
            currentAccessoire.title != "Default Title"
              ? currentAccessoire.title
              : "Sans Option";
          item.link = currentAccessoire.product_link;
          item.priceInCts = parseInt(currentAccessoire.price_no_money);
          item.cashPriceInCts = parseInt(currentAccessoire.price_no_money);
        }
        if (toGetPrice) {
          item.unitaryPriceInCts = parseInt(currentAccessoire.price_no_money);
          item.unitaryCashPriceInCts = parseInt(
            currentAccessoire.price_no_money
          );
        }
        _items.push(item);
      }
    }
    return _items;
  };

  /**
   * Popup du preview du panier
   */

  const popupCart = document.querySelector(".popup.cart");

  popupCart?.querySelector(".close")?.addEventListener("click", () => {
    popupCart.classList.remove("active");
  });

  document
    .querySelector(".controls .preview-total")
    ?.addEventListener(".click", () => {
      popupCart.classList.add("active");
    });

  const handleZeros = (_entry) => {
    let _value = _entry;

    // On gère les zéros en fin de prix
    if (_entry.includes(",")) {
      let _afterCom = _value.split(",")[1];
      if (_afterCom.length === 1) _value = _value + "0";
    } else {
      _value = _value + ",00";
    }

    return _value;
  };

  const calculateGlobalCart = (_string) => {
    // On converti le string en float
    let _globalCart = parseFloat(_string.replace(",", "."));

    // On ajoute le bon montant en fonction du modèle choisi
    if (SCOOTER.model === 3000) {
      _globalCart += 540;
    } else if (SCOOTER.model === 4700) {
      _globalCart += 720;
    }

    // On converti le float en string
    _globalCart = _globalCart.toString().replace(".", ",");

    // On gère les zéros
    _globalCart = handleZeros(_globalCart);

    return _globalCart;
  };

  const isLeasingProduct = document.querySelector(".wrapper-scooter-location");

  if (isLeasingProduct) {
    document.getElementById("amount").textContent = 100 + " € / mois";

    const leasingPrice = await getLeasingPrice({
      items: getItemsInCartForLeasing({ toGetPrice: true }),
    });

    // On update le prix total du panier
    const leasingForMonths = leasingPrice.price[
      "RENT_PRODUCT_WITH_REDEMPTION"
    ].currents.find(
      (current) => current.durationInMonths === LEASING_NUMBER_MONTHS
    );
    document.getElementById("amount").textContent =
      (leasingForMonths.monthlyPayment.priceInCts / 100)
        .toString()
        .replace(".", ",") + " € / mois";
  }

  const updateCart = async () => {
    // On réinitialise le preview du panier
    popupCart.querySelector(".accessoires").innerHTML = "";

    // Pour tous les accessoires sélectionnés
    for (let accessoire of document.querySelectorAll(
      ".accessoires .in-cart, .services .in-cart"
    )) {
      let _title = accessoire.querySelector(".title").textContent;
      let _price = accessoire.querySelector(".price").textContent;
      let _image = accessoire.querySelector(".image-wrapper img")?.src;
      let _variant = null;
      if (accessoire.querySelector(".allVariants") !== null) {
        _variant = accessoire.querySelector(".allVariants").text;
      }
      // On ajoute la ligne dans le preview du panier
      popupCart
        .querySelector(".accessoires")
        .appendChild(createLine(_title, _price, _image, _variant));
    }

    // On update la date estimée
    if (
      document.querySelector("#productSelect") &&
      allProducts.scooter.length > 0
    ) {
      let date_estimee = allProducts.scooter
        ? allProducts.scooter.filter(
            (product) =>
              product.id === document.querySelector("#productSelect").value
          )[0].date_estimee
        : null;
      if (date_estimee && date_estimee != "") {
        document.getElementById("livraison_estimee_label").style.display =
          "block";
        document.getElementById("livraison_estimee").innerHTML = date_estimee;
      } else {
        document.getElementById("livraison_estimee_label").style.display =
          "none";
      }
    } else {
      if (document.getElementById("livraison_estimee_label")) {
        document.getElementById("livraison_estimee_label").style.display =
          "none";
      }
    }

    const isLeasingProduct = document.querySelector(
      ".wrapper-scooter-location"
    );

    if (isLeasingProduct) {
      const leasingPrice = await getLeasingPrice({
        items: getItemsInCartForLeasing({ toGetPrice: true }),
      });
      const leasingCartUrl = await getLeasingCartUrl({
        items: getItemsInCartForLeasing({ toGetPrice: false }),
      });

      // On update le prix total du panier
      const leasingForMonths = leasingPrice.price[
        "RENT_PRODUCT_WITH_REDEMPTION"
      ].currents.find(
        (current) => current.durationInMonths === LEASING_NUMBER_MONTHS
      );
      document.getElementById("amount").textContent =
        (leasingForMonths.monthlyPayment.priceInCts / 100)
          .toString()
          .replace(".", ",") + " € / mois";
    }
    if (!isLeasingProduct) {
      // On update le prix total du panier
      let _cartPrice = getCartPrice();
      document.getElementById("amount").textContent = _cartPrice + " €";
      document.getElementById("original-price").textContent =
        calculateGlobalCart(_cartPrice) + " €";
    }
  };

  const VIRTUAL_CART = [];
  const SCOOTER = {
    situation: "france",
    model: 3000,
  };

  const getVariantName = (options) => {
    let selected = "",
      i = 0;
    // On créé un string qui reprend le nom du variant
    for (let option of options) {
      selected +=
        i > 0 ? " / " + option.dataset.value : "" + option.dataset.value;
      i++;
    }
    return selected.replace(/(\r\n|\n|\r)/gm, "");
  };

  /**
   * Sélection des options du scooter
   * */
  const selectVariant = (product, scooter = false) => {
    // On récupère l'id du produit
    const _id = product.dataset.id;

    // On reconstruit le nom de la variation
    let selected = getVariantName(
      product.querySelectorAll(".option.active .value")
    );
    const $options = Array.from(product.querySelector(`.allVariants`));
    const optionToSelect = $options.find(
      (item) => item.text.split(" | ")[0] === selected
    );

    // On sélectionne la bonne variante dans le select
    optionToSelect.selected = true;

    let _variantId = Number(optionToSelect.value);

    if (!scooter) {
      product.querySelector(".price").textContent =
        optionToSelect.text.split(" | ")[1] + " €";
      product.dataset.variant = _variantId;
    }
  };

  /**
   * Sélection des options du scooter
   * */
  for (let optionCategory of document.querySelectorAll(".scooter .options")) {
    // Pour chaque option
    for (let option of optionCategory.querySelectorAll(".option")) {
      // On sélectionne une option
      option?.addEventListener("click", async () => {
        reset(optionCategory.querySelectorAll(".option"), "active");
        option.classList.add("active");
        selectVariant(document.querySelector(".scooter"), "scooter");
        await updateCart();
      });
    }
  }

  /**
   * Changement de couleur automatique du Top Case et du siège
   */

  for (let color of document.querySelectorAll(
    ".scooter .options.couleur .option"
  )) {
    color?.addEventListener("click", function () {
      // Top Case
      let _color = this.querySelector("h4").dataset.value.toLowerCase();
      document.querySelector(`.tc-${_color}`)?.click();
      // Siège
      if (document.querySelector(".act-form .scooter .siege") != undefined) {
        document.querySelector(
          ".atc-form .scooter .siege .option.beige"
        ).style.backgroundImage = `url(https://cdn.shopify.com/s/files/1/0609/2590/3040/t/2/assets/siege-${_color}-beige.jpg)`;
        document.querySelector(
          ".atc-form .scooter .siege .option.noir"
        ).style.backgroundImage = `url(https://cdn.shopify.com/s/files/1/0609/2590/3040/t/2/assets/siege-${_color}-noir.jpg)`;
      }
    });
  }

  /**
   * Pour tous les accessoires
   * */
  for (let product of document.querySelectorAll(
    ".accessoires .product, .services .product"
  )) {
    // Sélection d'une variante
    for (let optionCategory of product.querySelectorAll(".options")) {
      // Pour chaque option
      for (let option of optionCategory.querySelectorAll(".option")) {
        // On sélectionne une option
        option.addEventListener("click", async (e) => {
          e.stopPropagation();
          reset(optionCategory.querySelectorAll(".option"), "active");
          option.classList.add("active");
          selectVariant(product);
          await updateCart();
        });
      }
    }

    // Ajout au panier
    product.addEventListener("click", async function () {
      if (this.classList.contains("active")) {
        product
          .querySelector(".zone-options")
          ?.addEventListener("click", (e) => {
            e.stopPropagation();
          });

        // On réajuste les classes du bouton d'ajout au panier
        this.classList.remove("active");
        product.classList.remove("in-cart");
      } else {
        // On réajuste les classes du bouton d'ajout au panier
        this.classList.add("active");
        product.classList.add("in-cart");
      }
      await updateCart();
    });
  }

  // Situation
  for (let situation of document.querySelectorAll(".situation .option")) {
    situation.addEventListener("click", function () {
      let _situation = this.dataset.situation;
      if (
        _situation === "france" ||
        _situation === "paris" ||
        _situation === "pro"
      ) {
        SCOOTER.situation = _situation;
      }
    });
  }

  /**
   * Pré-configuration du scooter
   */

  const isColor = (color) => {
    let _color = color.toLowerCase();
    if (
      _color === "bleu" ||
      _color === "vert" ||
      _color === "beige" ||
      _color === "gris" ||
      _color === "noir"
    )
      return true;
  };

  if (window.location.hash) {
    let _hash = window.location.hash.replace("#", "");
    if (isColor(_hash)) {
      document.querySelector(`.scooter .wrapper-color .opt-${_hash}`).click();
    }
  }

  /**
   * FAQ
   */

  for (let question of document.querySelectorAll(".faq .question")) {
    question.addEventListener("click", function () {
      this.classList.contains("active")
        ? question.classList.remove("active")
        : question.classList.add("active");
    });
  }

  /**
   * Features
   */

  const tabs = document.querySelectorAll(".tabs-features .tab");

  for (let tab of tabs) {
    tab.addEventListener("click", function () {
      reset(tabs, "active");
      reset(document.querySelectorAll(".wrapper-features .feature"), "active");
      document
        .querySelector(
          ".wrapper-features .feature:nth-child(" + this.dataset.index + ")"
        )
        .classList.add("active");
      this.classList.add("active");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".splide-temoignages") != null) {
      const sliderTemoignages = new Splide(".splide-temoignages", {
        perPage: 3,
        type: "loop",
        autoplay: true,
        interval: 2000,
        pagination: false,
        breakpoints: {
          500: {
            perPage: 1,
          },
        },
        arrows: false,
      });

      sliderTemoignages.mount();
    }

    if (document.querySelector(".splide-partenaires") != null) {
      const sliderPartenaires = new Splide(".splide-partenaires", {
        perPage: 5,
        loop: true,
        arrows: false,
        type: "loop",
        autoplay: true,
        interval: 2000,
        pagination: false,
        breakpoints: {
          500: {
            perPage: 2,
          },
        },
      });

      sliderPartenaires.mount();
    }
  });

  /**
   * Blog
   */

  let _index = 1;

  for (let heading of document.querySelectorAll(
    ".article-content .article h2"
  )) {
    let _slug = "#chapitre-" + _index;
    heading.id = _slug;
    const _chapter = document.createElement("a");
    _chapter.href = _slug;
    _chapter.textContent = heading.textContent;
    _chapter.classList.add("chapitre");
    document.querySelector(".article-content .chapters").appendChild(_chapter);
    _index++;
  }

  /**
   * Sticky colors
   */

  if (document.querySelector(".sticky-colors")?.length) {
    let tl_sticky_colors = gsap.timeline({
      scrollTrigger: {
        trigger: ".sticky-colors",
        start: "top top",
        end: "300%",
        pin: true,
        scrub: true,
      },
    });

    tl_sticky_colors
      .to(".sticky-colors .color.beige", {
        duration: 1,
        webkitClipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        ease: Power0.easeNone,
      })
      .to(".sticky-colors .color.bleu", {
        duration: 1,
        webkitClipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        ease: Power0.easeNone,
      })
      .to(".sticky-colors .color.gris", {
        duration: 1,
        webkitClipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        ease: Power0.easeNone,
      })
      .to(".sticky-colors .color.vert", {
        duration: 1,
        webkitClipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        ease: Power0.easeNone,
      });
  }

  /**
   * Panier
   */

  /*
 
  const round = (value) => {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }
 
  const convertStringToFloat = (string) => {
    let _value = parseFloat(string.replace(',', '.'));
    return _value;
  }
 
  const convertPrice = (string) => {
    let _value = parseFloat(string.replace('€', '').replace(',', '.').replace(' ',''));
    return _value;
  }
 
  const calculateAllCart = () => {
    let _amout = 0;
    for(let item of cartItems) {
      let _itemPrice = round(convertPrice(item.querySelector('.price').textContent));
      _amout += _itemPrice;
    }
    document.getElementById('cart-price').textContent = round(_amout);
  }
 
  */

  const cartItems = document.querySelectorAll(".cart .item");

  for (let item of cartItems) {
    let _priceElt = item.querySelector(".price");
    let _originalPrice = item.dataset.price;

    // On gère le prix de chaque item
    item.querySelector(".number").addEventListener("change", (e) => {
      //let _number = e.target.value;
      //let _price = convertPrice(_originalPrice);
      //_priceElt.textContent = round(_number * _price) + '€';
      //calculateAllCart();
    });
  }

  let hasClickedCheckout = false;

  document
    .querySelector(".button-checkout")
    ?.addEventListener("click", function (e) {
      if (document.getElementById("cgv").checked) {
        document.querySelector(".alert-cgv").classList.remove("active");
        if (!hasClickedCheckout) {
          this.innerHTML =
            '<img class="h-6" src="https://cdn.shopify.com/s/files/1/0609/2590/3040/t/2/assets/loader.gif?v=531280867754825472" role="presentation">';
          hasClickedCheckout = true;
        } else {
          e.preventDefault();
        }
      } else {
        e.preventDefault();
        document.querySelector(".cgv").classList.add("alert");
        setTimeout(() => {
          document.querySelector(".cgv").classList.remove("alert");
        }, 2000);
        document.querySelector(".alert-cgv").classList.add("active");
      }
    });

  // Gorgias
  gorgiasChat.init().then(async (chat) => {
    chat.hidePoweredBy(true);
  });
})();
